export const daysUntilTheEndOfTheMonth = () => {
  const today = new Date();
  const daysInMonth = new Date(
    today.getFullYear(),
    today.getMonth() + 1,
    0
  ).getDate();
  const daysRemaining = daysInMonth - today.getDate();
  return daysRemaining;
};

export const getDiffDaysSinceToday = (dateString) => {
  if (!dateString) return -1;
  const date = new Date(dateString);
  const today = new Date();
  const diffTime = Math.abs(date - today);
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return diffDays;
};
